import type { QuoteStatus } from "@/api/types";
import { Badge } from "@/components/crm/Badge";

const MAP: Record<QuoteStatus, { label: string; tone: "neutral" | "brand" | "ok" | "danger" | "warn" }> = {
  draft: { label: "Draft", tone: "neutral" }, sent: { label: "Sent", tone: "brand" }, accepted: { label: "Accepted", tone: "ok" },
  rejected: { label: "Declined", tone: "danger" }, superseded: { label: "Superseded", tone: "neutral" }, expired: { label: "Expired", tone: "warn" },
};

export function QuoteStatusBadge({ status }: { status: QuoteStatus }) {
  const s = MAP[status];
  return <Badge tone={s.tone}>{s.label}</Badge>;
}
